import BaseListagem from "components/BaseListagem";
import Conta from "model/administracao/cadastro/Conta";
import Pessoa from "model/administracao/cadastro/Pessoa";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import UsuarioService from "service/administracao/cadastro/UsuarioService";
import { IdMatchModeOptions, TextMatchModeOptions, booleanFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const usuarioService = new UsuarioService();
const contaService = new ContaService();

const defaultFilters: DataTableFilterMeta = {
    nome: {
        constraints: [
            {
                value: null,
                matchMode: FilterMatchMode.STARTS_WITH,
            }
        ],
        operator: FilterOperator.AND
    },

    email: {
        constraints: [
            {
                value: null,
                matchMode: FilterMatchMode.STARTS_WITH,
            }
        ],
        operator: FilterOperator.AND
    },

    pessoa: {
        constraints: [
            {
                value: null,
                matchMode: FilterMatchMode.EQUALS,
            }
        ],
        operator: FilterOperator.AND
    },
    ativo: {
        constraints: [
            {
                value: true,
                matchMode: FilterMatchMode.EQUALS,
            }
        ],
        operator: FilterOperator.AND
    }
}

export default function UsuarioListagem() {

    const [queryParameters] = useSearchParams();

    const [conta, setConta] = useState<Conta>(new Conta());
    const [titulo, setTitulo] = useState<string>('Usuários');
    const [pessoas, setPessoas] = useState<Pessoa[]>([])

    useEffect(() => {

        const idConta = queryParameters.get('idConta');
        if (idConta) {

            contaService.consultar(parseInt(idConta)).then(contaParam => {

                setConta(contaParam);
                setTitulo(`Usuários da Conta ${contaParam.nome}`);
            });
            usuarioService.pessoas(parseInt(idConta)).then((data) => {
                setPessoas(data);
            }).catch((error) => {
                console.log(error);
            })
        } else {
            usuarioService.pessoas().then((data) => {
                setPessoas(data);
            }).catch((error) => {
                console.log(error);
            })
        }

    }, []);

    const pessoaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={pessoas}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={usuarioService} showRemoveButton={false} urlService="/usuario" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="usuario">
            <Column
                field="nome" header="Nome"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column
                field="email" header="E-mail"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column
                field="pessoa.nome" header="Cliente" filterField="pessoa"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
                filterElement={pessoaFilterTemplate}
            />
            <Column field="ativo" header="Ativo" body={(data) => data.ativo ? 'Sim' : 'Não'}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={booleanFilterTemplate}
            />
        </BaseListagem>
    )
}
